import { Box, makeStyles, Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { FontSizes } from '../../../core/config/mainTheme';
import { border, toCssValue } from '../../../core/utils/theme.utils';
import { BackportingEnums } from '../../../generated/compat/backportingEnums';
import { useCompaniesState } from '../../../pages/FinancialData/shared/CompanyContext/CompanyContext';

interface Props {
  title: string;
  showCurrency?: boolean;
  actions?: React.ReactNode;
  children: React.ReactNode;
  ccy?: BackportingEnums.CcyEnum;
  consolidation?: boolean;
  currenciesOfAccounts?: string;
}

const ContentBlock: React.FC<Props> = ({
  title,
  children,
  actions,
  showCurrency = false,
  ccy,
  consolidation = undefined,
  currenciesOfAccounts,
}) => {
  const classes = useStyles();
  const { company } = useCompaniesState();
  const [currencyText, setCurrencyText] = useState<string>();

  useEffect(() => {
    if (company && showCurrency && ccy) {
      const accCcy = company.companyInfo?.currencyOfAccounts;
      const consolidationText =
        consolidation === true
          ? 'Consolidated;'
          : consolidation === false
          ? 'Non-consolidated; '
          : '';
      const newCurrencyValue =
        accCcy === ccy || ccy === 'ACTUAL' ? currenciesOfAccounts || accCcy : `Converted to ${ccy}`;
      setCurrencyText(consolidationText + newCurrencyValue);
    }
  }, [company, ccy, showCurrency, consolidation, currenciesOfAccounts]);

  return (
    <Paper square className={classes.contentBlock}>
      <Box className={classes.contentBlockTitle}>
        {title} {currencyText ? `(${currencyText})` : null}
        {actions && <Box className={classes.actions}>{actions}</Box>}
      </Box>
      <Box>{children}</Box>
    </Paper>
  );
};
const useStyles = makeStyles((theme) => ({
  contentBlock: {
    marginBottom: theme.spacing(8),
    width: '100%',
  },
  actions: {
    margin: toCssValue([-1 * theme.spacing(4), -1 * theme.spacing(2), -1 * theme.spacing(3), 0]),
  },
  contentBlockTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    borderBottom: border(theme.palette.divider),
    padding: toCssValue([theme.spacing(4), theme.spacing(5), theme.spacing(3)]),
    fontWeight: FontSizes.fontWeight.bold,
    color: theme.palette.grey[900],

    '&::before': {
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      content: '" "',
      borderLeft: border(theme.palette.primary.light, theme.spacing(2)),
    },
  },
}));

export default ContentBlock;
